import {
  DialogContent,
  Dialog,
  DialogProps,
  DialogActions,
  useEventCallback,
  Grid,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';
import { PmiButton } from 'shell/components/shared/button';
import { styled } from '@mui/styles';
import { StatementsFormVM } from 'front-office/view-models/statements/statements-form';
import { FormikProps, useFormikContext } from 'formik';
import StatementsAnpr from './statements';
import IdentityCard from 'front-office/components/shared/identity-card';
import { AccordionGeneralityFormVM } from 'front-office/view-models/certificate/generality-form';
import WidowerWithChildren from './statements/widower-with-children';
import DeceasedWithWill from './statements/deceased-with-will';
import OtherSuccession from './statements/other-succession';
import Cheque from './statements/cheque';
import GenericDeclaration from './statements/generic-declaration';
import PaymentCertificate from 'front-office/components/shared/payment';
import FormulaGenericDeclaration from './statements/formula';
import PmiTextField from 'shell/components/shared/text-field';

export const PmiDialog = styled((props: DialogProps) => <Dialog {...props} />)((props) => ({
  '& .MuiDialog-paper': props.fullScreen
    ? {
        minWidth: 'unset',
        maxWidth: '100%',
      }
    : {
        minWidth: '50rem',
        maxWidth: '800px',
      },
}));

interface ModalCertificateProps {
  open: boolean;
  onClose: (open: boolean) => void;
  onRequestCertificate: (values: StatementsFormVM, context: FormikProps<StatementsFormVM>) => void;
}

const ModalCertificate = ({
  open,
  onClose,
  onRequestCertificate,
}: ModalCertificateProps): React.ReactElement => {
  const formContext = useFormikContext<StatementsFormVM>();

  const onFieldGeneralityChange = useEventCallback(
    (
      key: keyof AccordionGeneralityFormVM,
      value: AccordionGeneralityFormVM[keyof AccordionGeneralityFormVM]
    ) => {
      formContext.setFieldValue('generality', {
        ...formContext.values.generality,
        [key]: value,
      });
    }
  );

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      open={open}
      aria-labelledby="alert-dialog-title"
      fullScreen={fullScreen}
      aria-describedby="alert-dialog-description"
    >
      <PmiDialogTitle id="alert-dialog-title" backgroundColor="primary" color="white">
        Richiesta Dichiarazione
      </PmiDialogTitle>
      <DialogContent style={{ padding: '30px 24px' }}>
        <StatementsAnpr />
        {formContext.values.statements ? (
          <Grid container spacing={2}>
            <IdentityCard
              onFieldGeneralityChange={onFieldGeneralityChange}
              generality={
                formContext.values.accountholder?.account?.generality ||
                formContext.values.generality
              }
            />
            {/* <Grid item xs={12}>
              <Grid item container spacing={2}>
                <Grid item xs={12}>
                  <PmiTextField
                    label="Dichiarazione aggiuntiva"
                    aria-label="Dichiarazione"
                    id="declaration-added"
                    fullWidth
                    multiline
                    rows={5}
                    inputProps={{
                      maxLength: '240',
                    }}
                    value={formContext.values?.declarationAdded || ''}
                    onChange={(event) => {
                      formContext.setFieldValue('declarationAdded', event.target.value);
                    }}
                  />
                </Grid>
              </Grid>
            </Grid> */}
            {formContext.values.statements?.key?.codiceDocumento === '1' ? (
              <Grid item xs={12}>
                <GenericDeclaration />
              </Grid>
            ) : undefined}
            {formContext.values.statements?.key?.codiceDocumento === '2' ? (
              <Grid item xs={12}>
                <WidowerWithChildren />
                <FormulaGenericDeclaration />
              </Grid>
            ) : undefined}
            {formContext.values.statements?.key?.codiceDocumento === '3' ? (
              <Grid item xs={12}>
                <DeceasedWithWill />
                <FormulaGenericDeclaration />
              </Grid>
            ) : undefined}
            {formContext.values.statements?.key?.codiceDocumento === '4' ? (
              <>
                {/* <Grid item xs={12}>
                  <Grid item container spacing={2}>
                    <Grid item xs={12}>
                      <PmiTextField
                        label="Dichiarazione aggiuntiva"
                        aria-label="Dichiarazione"
                        id="declaration-added"
                        fullWidth
                        multiline
                        rows={5}
                        inputProps={{
                          spellCheck: true,
                          lang: 'it',
                        }}
                        value={formContext.values?.declarationAdded || ''}
                        onChange={(event) => {
                          formContext.setFieldValue('declarationAdded', event.target.value);
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid> */}
                <Grid item xs={12}>
                  <OtherSuccession />
                  <FormulaGenericDeclaration />
                </Grid>
              </>
            ) : undefined}
            {formContext.values.statements?.key?.codiceDocumento === '5' ? (
              <>
                <Grid item xs={12}>
                  <Cheque />
                </Grid>
                <Grid item xs={12}>
                  <Grid item container spacing={2}>
                    <Grid item xs={12}>
                      <PmiTextField
                        label="Dichiarazione aggiuntiva"
                        aria-label="Dichiarazione"
                        id="declaration-added"
                        fullWidth
                        multiline
                        rows={5}
                        value={formContext.values?.declarationAdded || ''}
                        onChange={(event) => {
                          formContext.setFieldValue('declarationAdded', event.target.value);
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </>
            ) : undefined}
          </Grid>
        ) : undefined}
        <PaymentCertificate />
      </DialogContent>
      <DialogActions>
        <PmiButton
          variant="contained"
          color="primary"
          type="button"
          onClick={() => onRequestCertificate(formContext.values, formContext)}
        >
          Richiesta Dichiarazione
        </PmiButton>
        <PmiButton variant="outlined" color="cdmBrand" type="button" onClick={() => onClose(false)}>
          Chiudi
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
};

ModalCertificate.displayName = 'Modal request certificate';

export default ModalCertificate;
